<template>
  <RF-Dialog class="cms-editar-dialog"
  :cpntStatus='statusGeral'
  :cpntLargura='"750px"'
  :cpntTitulo='"Informações da comissão"'

  :cpntOnFecharDialog='cmsEditarFecharFormulario'>
    <template slot="conteudo">
      <div class="cms-editar">
        <table v-if="Object.keys(dados).length >= 1">
          <tr>
            <td style="width: 130px;">
              <div class="titulo">
                Venda
              </div>
              <div class="valor">
                <span v-html="dados.cod_venda.length <= 4 ? ('0000' + dados.cod_venda).slice(-4) : dados.cod_venda"></span>
              </div>
            </td>

            <td style="width: calc((100% - 130px) / 3);">
              <div class="titulo">
                Contato
              </div>
              <div class="valor">
                <RF-Button class="bt-link-cadastro"
                  :cpntId='"RF-Tabela-Vue--link-contato--" + dados.cod_venda_id_con'
                  :cpntStatus='""'
                  :cpntTipo='"texto"'
                  :cpntClass='[ "btn", "btn-default" ]'

                  @onClickButton='cmsEditarInformacoesCadastro'>
                  <template slot="conteudo">
                  <!-- COLOCA O NOME DO CONTATO -->
                  <span v-html="dados.cod_venda_id_con_nome"></span>

                  <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
                  <span v-if='dados.cod_venda_id_con_pessoa === "j" && dados.cod_venda_id_con_empresa !== ""' v-html="' (' + dados.cod_venda_id_con_empresa + ')'"></span>

                  <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
                  <b v-if='dados.cod_venda_id_con_status !== "1"' v-html="'[Excluído]'"></b>
                  </template>
                </RF-Button>
              </div>
            </td>

            <td style="width: calc((100% - 130px) / 3);" v-if="[ '', null, undefined, '0' ].indexOf(dados.cod_venda_id_pet) === -1">
              <div class="titulo">
                Pet
              </div>
              <div class="valor">
                <RF-Button class="bt-link-cadastro font-tp-1"
                  :cpntId='"RF-Tabela-Vue--link-pet--" + dados.cod_venda_id_pet'
                  :cpntStatus='""' 
                  :cpntTipo='"texto"'
                  :cpntClass='[ "btn", "btn-default" ]'

                  @onClickButton='cmsEditarInformacoesCadastro'>
                  <template slot="conteudo">
                    <!-- COLOCA O NOME DO PET -->
                    <span v-html="dados.cod_venda_id_pet_nome"></span>

                    <!-- COLOCA O NOME DO PET -->
                    <span v-if="[ '', null, undefined ].indexOf(dados.cod_venda_id_pet_subespecie_nome) === -1" v-html="' (' + dados.cod_venda_id_pet_subespecie_nome + ')'"></span>

                    <!-- VERIFICA SE O PET ESTA EXCLUIDO -->
                    <b v-if='dados.cod_venda_id_pet_status !== "1"' v-html="'[Excluído]'"></b>
                  </template>
                </RF-Button>
              </div>
            </td>

            <td style="width: calc((100% - 130px) / 3);" v-if="[ '', null, undefined, '0' ].indexOf(dados.cod_venda_id_vei) === -1">
              <div class="titulo">
                Veículo
              </div>
              <div class="valor">
                <RF-Button class="bt-link-cadastro font-tp-1"
                  :cpntId='"RF-Tabela-Vue--link-veiculo--" + dados.cod_venda_id_vei'
                  :cpntStatus='""' 
                  :cpntTipo='"texto"'
                  :cpntClass='[ "btn", "btn-default" ]'

                  @onClickButton='cmsEditarInformacoesCadastro'>
                  <template slot="conteudo">
                    <!-- COLOCA O NOME DO VEICULO -->
                    <span v-html="dados.cod_venda_id_vei_placa"></span>

                    <!-- COLOCA O MODELO NOVO DA API -->
                    <!-- cod_venda_id_vei_id_mod_nome -->
                    <template v-if="[ '', null, undefined ].indexOf(dados.cod_venda_id_vei_ref_modelo_j_modelo_marca) === -1 || [ '', null, undefined ].indexOf(dados.cod_venda_id_vei_ref_modelo_j_modelo) === -1">
                      <span v-if="[ '', null, undefined ].indexOf(dados.cod_venda_id_vei_ref_modelo_j_modelo_marca) === -1" v-html="' ' + dados.cod_venda_id_vei_ref_modelo_j_modelo_marca"></span>
                      <span v-if="[ '', null, undefined ].indexOf(dados.cod_venda_id_vei_ref_modelo_j_modelo) === -1" v-html="' ' + dados.cod_venda_id_vei_ref_modelo_j_modelo"></span>
                    </template>

                    <!-- COLOCA O MODELO ANTIGO DA API-->
                    <template v-else>
                      <span v-if="[ '', null, undefined ].indexOf(dados.cod_venda_id_vei_id_mar_nome) === -1" v-html="' ' + dados.cod_venda_id_vei_id_mar_nome"></span>
                      <span v-if="[ '', null, undefined ].indexOf(dados.cod_venda_id_vei_id_mod_nome) === -1" v-html="' ' + dados.cod_venda_id_vei_id_mod_nome"></span>
                    </template>

                    <!-- VERIFICA SE O VEICULO ESTA EXCLUIDO -->
                    <b v-if='dados.cod_venda_id_vei_status !== "1"' v-html="'[Excluído]'"></b>
                  </template>
                </RF-Button>
              </div>
            </td>
          </tr>

          <!-- <tr>
            <td colspan="3">
              <hr/>
            </td>
          </tr> -->
        </table>
        
        <table>
          <tr>
            <td style="width: calc(100% / 3);">
              <div class="titulo">
                Item
              </div>
              <div class="valor">
                <RF-Button class="bt-link-cadastro"
                  :cpntId='"cms-editar-bt--item--" + dados.item_id'
                  :cpntStatus='""'
                  :cpntTipo='"texto"'
                  :cpntClass='[ "btn", "btn-default" ]'

                  @onClickButton='cmsEditarInformacoesCadastro'>
                  <template slot="conteudo">
                  <!-- COLOCA O NOME DO CONTATO -->
                  <span v-html="dados.item_nome"></span>

                  <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
                  <b v-if='dados.item_status !== "1"' v-html="'[Excluído]'"></b>
                  </template>
                </RF-Button>
              </div>
            </td>

            <td style="width: calc(100% / 3);">
              <template v-if="[ '', null, undefined ].indexOf(dados.cms_fec_id) !== -1">
                &nbsp;
              </template>
              <template v-else-if="[ '', null, undefined ].indexOf(dados.cms_fec_id) === -1">
                <div class="titulo">
                  Fechamento
                </div>
                <div class="valor">
                  <RF-Button class="bt-link-cadastro"
                    :cpntId='"cms-editar-bt--link_cms--" + dados.cms_fec_id'
                    :cpntStatus='""'
                    :cpntTipo='"texto"'
                    :cpntTexto='"CMS " + ((dados.cms_fec_id.length <= 4 ? ("0000" + dados.cms_fec_id).slice(-4) : dados.cms_fec_id))'
                    :cpntClass='[ "btn", "btn-default" ]'

                    @onClickButton='cmsEditarInformacoesCadastro'>
                  </RF-Button>
                </div>
              </template>
            </td>

            <td style="width: calc(100% / 3);">
              <div class="titulo">
                Vendedor
              </div>
              <div class="valor">
                <RF-Componente v-if="Object.keys(comissionado).length >= 1" style="display: inline-block;"
                  :data-time='time'
                  :cpntTamanho='comissionado.tamanho'
                  :cpntModelo='comissionado.tipo'
                  :cpntStatus='comissionado.status'
                  :cpntId='comissionado.id'
                  :cpntClassDivField='comissionado.classDivField'
                  :cpntNome='comissionado.nome'
                  :cpntValue='comissionado.value'
                  :cpntValueRef='comissionado.valueRef'
                  :cpntOptions='comissionado.options'
                  :cpntKeyValue='comissionado.keyValue'
                  :cpntKeyMostra='comissionado.keyMostra'
                  :cpntAutoComplete='comissionado.autocomplete'
                  :cpntDisabled='comissionado.disabled'
                  :cpntMostrar='comissionado.mostrar'
                  :cpntMensagem='comissionado.mensagem'
                  :cpntSelecioneNome='comissionado.selecioneNome'
                  :cpntSelecioneValue='comissionado.selecioneValue'
                  :cpntMensagemTipo='comissionado.mensagemTipo'
                  :cpntAdicinarOption='comissionado.adicinarOption'
                  :cpntMultiple='comissionado.multiple'
                  :cpntAllRegistro='comissionado.allRegistro'
                  :cpntExplica='comissionado.explica'
                  :cpntConfig='comissionado.config'
                  :cpntTabIndex='comissionado.tabIndex'
                  :cpntMaxLength='comissionado.maxLength'
                  :cpntOptionInicialNome='comissionado.optionInicialNome'
                  :cpntOptionInicialValue='comissionado.optionInicialValue'

                  :cpntOnChange='comissionado.onChange'
                  :cpntOnBlur='comissionado.onBlur'
                  :ref='comissionado.id'
                ></RF-Componente>               
              </div>
            </td>
          </tr>

          <tr v-if="[ '', null, undefined, '0' ].indexOf(dados.cms_com_id) === -1">
            <td style="width: calc(100% / 3);">
              <template v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true">
                <div class="titulo">
                  Base de Cálculo
                </div>
                <div class="valor">
                  <span>R$ </span>
                  <span v-html="dados._cms_bc"></span>
                </div>
              </template>
            </td>
            
            <td style="width: calc(100% / 3);">
              <div class="titulo">
                Porcentagem
              </div>
              <div class="valor">
                <RF-Componente v-if="[ '', null, undefined ].indexOf(cms_por) === -1 && Object.keys(cms_por).length >= 1 && [ '', null, undefined ].indexOf(dados.cms_fec_id) !== -1"
                  :data-time='time'
                  :cpntTamanho='cms_por.tamanho'
                  :cpntModelo='cms_por.tipo'
                  :cpntStatus='cms_por.status'
                  :cpntId='cms_por.id'
                  :cpntClassDivField='cms_por.classDivField'
                  :cpntNome='cms_por.nome'
                  :cpntValue='cms_por.value'
                  :cpntValueRef='cms_por.valueRef'
                  :cpntOptions='cms_por.options'
                  :cpntKeyValue='cms_por.keyValue'
                  :cpntKeyMostra='cms_por.keyMostra'
                  :cpntAutoComplete='cms_por.autocomplete'
                  :cpntDisabled='cms_por.disabled'
                  :cpntMostrar='true'
                  :cpntMensagem='cms_por.mensagem'
                  :cpntSelecioneNome='cms_por.selecioneNome'
                  :cpntSelecioneValue='cms_por.selecioneValue'
                  :cpntMensagemTipo='cms_por.mensagemTipo'
                  :cpntAdicinarOption='cms_por.adicinarOption'
                  :cpntMultiple='cms_por.multiple'
                  :cpntAllRegistro='cms_por.allRegistro'
                  :cpntExplica='cms_por.explica'
                  :cpntConfig='cms_por.config'
                  :cpntTabIndex='cms_por.tabIndex'
                  :cpntMaxLength='cms_por.maxLength'
                  :cpntOptionInicialNome='cms_por.optionInicialNome'
                  :cpntOptionInicialValue='cms_por.optionInicialValue'

                  :cpntOnChange='cms_por.onChange'
                  :cpntOnBlur='cms_por.onBlur'
                  :cpntOnKeyPressEnter='cms_por.onKeyPressEnter'
                  :ref='cms_por.id'
                ></RF-Componente>
                <template v-else>
                  <span v-html="dados._cms_por"></span>
                  <span>%</span>
                </template>

                <div v-if="[ '', null, undefined, '0' ].indexOf(dados.cms_com_id) === -1 && [ '', null, undefined ].indexOf(dados.cms_fec_id) !== -1 && dados._cms_por !== dados._cms_por_ini" style="font-size: 12px; color: #f16161; text-align: center; font-weight: bold;">
                  Uma diferença foi encontrada para porcentagem atual {{ dados._cms_por }}% e a configuração {{ dados._cms_por_ini }}% deste item.

                  <span style="margin-left: 10px;">
                    <RF-Button
                      :cpntId='"cms-editar-bt--" + dados.item_id'
                      :cpntStatus='""'
                      :cpntTipo='"icone"'
                      :cpntIcone='{ tipo: "atualizar" }'
                      :cpntClass='[ "btn", "btn-default", "btn-sm" ]'

                      @onClickButton='cmsEditarAtualizarComissionado'>
                    </RF-Button>
                  </span>
                </div>
              </div>
            </td>

            <td style="width: calc(100% / 3);">
              <template v-if="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true">
                <div class="titulo">
                  Valor
                </div>
                <div class="valor">
                  <span>R$ </span>
                  <span v-html="dados._cms_valor"></span>
                </div>
              </template>
            </td>
          </tr>
        </table>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .cms-editar > table {
    width: 100%;
  } 
    .cms-editar > table > tr > td {
      padding: 8px 0px;
    }
      .cms-editar > table > tr > td > .titulo {
        text-align: center;
      }
      .cms-editar > table > tr > td > .valor,
      .cms-editar > table > tr > td > .valor > button {
        /* font-weight: bold; */
        text-shadow: none;
        text-align: center;
      }
        .cms-editar > table > tr > td > .valor > button {
          padding: 0px;
          margin: 0px;
          min-height: auto !important;
        }

      /* .cms-editar > table > tr > td > hr {
        margin: 2px 0px;
      } */
</style>

<style>
.cms-editar-dialog > div > div > .rf-dialog-conteudo {
  min-height: 220px;
}
.cms-editar > table > tr > td > .valor > .rf-cpnt-group-input > .rf-input-group > input {
  border: 1px solid #CCC;
  border-radius: 4px;
  text-align: center;
}
</style>

<script>
  export default {
    props: {
      cpntId: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntTipo: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        atualizar: false,
        dados: {},
        comissionado: {},
        cms_por: {}
      }
    },
    mounted: function () {
      this.cmsEditarIniciar()
    },
    methods: {
      cmsEditarIniciar: function () {
        // SETA O STATUS DA TELA
        this.cmsEditarSetaStatusGeral('carregando')

        // VERIFICA SE FOI INFORMADO UM ID VALIDO
        if ([ '', null, undefined, '0', 0 ].indexOf(this.cpntId) !== -1) {
          this.cmsEditarSetaStatusGeral({ loc: 'WEB', cod: '409', err: 'Id informado (' + this.cpntId + ') é inválido.' })
        } else if ([ 'produto', 'servico' ].indexOf(this.cpntTipo) === -1) {
          this.cmsEditarSetaStatusGeral({ loc: 'WEB', cod: '409', err: 'Tipo informado (' + this.cpntTipo + ') é inválido.' })
        } else {
          // CHAMA A FUNÇÃO PARA CARREGAR OS DADOS SOLICITADOS
          this.cmsEditarCarregarDados()
        }
      },
      cmsEditarSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status       

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      cmsEditarFecharFormulario: function (atualizar) {
        this.cpntFecharFormulario((this.atualizar === true ? true : atualizar))
      },
      cmsEditarCarregarDados: function () {
        var self = this

        // INICIA O NOME DA ROTA QUE SERÁ BUSCADO OS DADOS NA API
        var router = ''

        // INICIA A QUERY GET
        var queryGet = { limit: { row: 0, qty: 1 }, type: 'list' }

        // SETA O QUERY GET
        queryGet.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'id', o: '=', v: self.cpntId } ] }

        // SETA OS TIPOS DE INFORMAÇÃO PARA CADA MODELO
        switch (this.cpntTipo) {
          case 'produto':
            // INICIA O NOME DA ROTA QUE SERÁ BUSCADO OS DADOS NA API
            router = '/venda/produto/get'

            // SETA OS CAMPOS QUE DEVEM RETORNAR
            queryGet.field = { id: null, id_pro: { j: { id: { a: 'item_id' }, nome: { a: 'item_nome' }, status: { a: 'item_status' } } } }
            break

          case 'servico':
            // INICIA O NOME DA ROTA QUE SERÁ BUSCADO OS DADOS NA API
            router = '/venda/servico/get'

            // SETA OS CAMPOS QUE DEVEM RETORNAR
            queryGet.field = { id: null, id_ser: { j: { id: { a: 'item_id' }, nome: { a: 'item_nome' }, status: { a: 'item_status' } } } }
            break
        }

        // SETA OS CAMPOS IGUAIS PARA OS DOIS TIPOS
        queryGet.field = Object.assign(queryGet.field, { cod_venda: { j: { cod_venda: null } }, cms_bc: null, cms_por: null, cms_fec_id: null, cms_valor: null, cms_com_id: null })

        // SETA A BUSCA DOS DADOS DO PET
        if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, null, null, null, null, false) === true) {
          queryGet.field.cod_venda.j = Object.assign(queryGet.field.cod_venda.j, { id_pet: { j: { nome: null, id_pet_subespecie: { j: { j_subespecie: { a: 'id_pet_subespecie_nome' } } }, status: null } } })
        }

        // SETA A BUSCA DOS DADOS DO VEICULO
        if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, null, null, null, null, false) === true) {
          queryGet.field.cod_venda.j = Object.assign(queryGet.field.cod_venda.j, { id_vei: { j: { placa: null, id_mod: { j: { nome: null } }, ref_modelo: { j: { j_modelo: null } }, status: null } } })
        }

        // SETA A BUSCA DOS DADOS DO CONTATO
        queryGet.field.cod_venda.j = Object.assign(queryGet.field.cod_venda.j, { id_con: { j: { nome: null, empresa: null, pessoa: null, status: null } } })

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        self.$store.state.comunicaAPI(router, 'POST', queryGet, function (apiSuccess) {
          if (apiSuccess.data.length !== 1) {
            self.cmsEditarSetaStatusGeral({ loc: 'WEB', cod: '409', err: 'Não foi possivel localizar o Id informado (' + self.cpntId + ').' })
          } else {
            // SETA OS DADOS RECEBIDOS
            self.dados = apiSuccess.data[0]

            // PEGA O VALOR RECEBIDO
            var alterado = self.dados.cms_por.split('.')

            // VERIFICA SE FOI ENCONTRADO UM VALOR
            if (alterado.length >= 2) {
              // VERIFICA SE TEM 4 CASAS DECIMAL E REMOVE AS DUAS ULTIMAS
              if (alterado[1].length === 4) {
                alterado[1] = alterado[1].substring(0, 2)
              }
  
              // ATUALIZA OS VALORES NA TABELA
              self.dados.cms_por = alterado.join('')
            }

            // FORMATA OS VALORES RECEBIDOS
            self.dados._cms_bc = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.dados.cms_bc)
            self.dados._cms_por = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.dados.cms_por)
            self.dados._cms_valor = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.dados.cms_valor)

            // CHAMA A FUNÇÃO PARA BUSCAR OS DADOS DO COMISSIONADO
            self.cmsEditarCarregarDadosComissionado()
          }
        }, self.cmsEditarSetaStatusGeral)
      },
      cmsEditarCarregarDadosComissionado: function () {
        var self = this

        // MONTA O QUERY GET
        var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id_con: { j: { nome: null } } }, where: { f: 'status', o: '=', v: '1' } }

        // REALIZA A BUSCA DOS DADOS NA API
        self.$store.state.comunicaAPI('/comissao/config/comissionado/get', 'POST', queryGet, function (apiSuccess) {
          self.comissionado = {
            tamanho: 57,
            tipo: 'select2',
            id: 'cms-detalhe-' + self.dados.cms_com_id,
            nome: '',
            keyMostra: [ 'id_con', ' - ', 'id_con_nome' ],
            keyValue: 'id_con',
            options: apiSuccess.data,
            value: self.dados.cms_com_id,
            onChange: function (value) {
              // SETA O VALOR RECEBIDO
              self.comissionado.value = value

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA ATUALIZAR O COMISSIONADO
              self.cmsEditarAtualizarComissionado()
            }
          }

          if (self.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 27 ], null, [ 51 ], null, [ 553 ], null, false) === true) {
            self.cms_por = {
              tipo: 'input',
              tamanho: 3,
              id: 'cms-editar--cms_por',
              nome: '',
              mostrar: false,
              value: self.dados._cms_por,
              valueIni: self.dados._cms_por,
              mask: 'valor',
              onChange: function (value) {
                // SETA O VALOR RECEBIDO
                self.cms_por.value = value
  
                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              },
              onBlur: self.cmsEditarAtualizarComissaoVendedor,
              onKeyPressEnter: self.cmsEditarAtualizarComissaoVendedor
            }
          }

          // CHAMA A FUNÇÃO PARA CARREGAR A % DE CONFIGURAÇÕS
          self.cmsEditarCarregarDadosItemComissionado()
        }, self.cmsEditarSetaStatusGeral)
      },
      cmsEditarCarregarDadosItemComissionado: function () {
        var self = this

        if ([ '', null, undefined, '0' ].indexOf(self.dados.cms_com_id) === -1 && [ '', null, undefined ].indexOf(self.dados.cms_fec_id) !== -1) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { cms_por: null }, where: { aAnd: [ { f: 'id_con', o: '=', v: self.dados.cms_com_id } ] } }
  
          // SETA QUAL É O PRODUTO QUE PRECISA COMPRAR
          if (self.cpntTipo === 'servico') {
            queryGet.where.aAnd.push({ f: 'id_ser', o: '=', v: self.dados.id_ser })
          } else if (self.cpntTipo === 'produto') {
            queryGet.where.aAnd.push({ f: 'id_pro', o: '=', v: self.dados.id_pro })
          }
  
          // REALIZA A BUSCA DOS DADOS NA API
          self.$store.state.comunicaAPI('/comissao/config/comissionado/' + self.cpntTipo + '/get/', 'GET', queryGet, function (apiSuccess) {
            // SETA OS DADOS RECEBIDOS
            self.dados.cms_por_ini = apiSuccess.data.length === 0 ? '0' : apiSuccess.data[0].cms_por
  
            // SETA O VALOR INICIAL
            var valor = self.dados.cms_por_ini
  
            // PEGA O VALOR RECEBIDO
            var alterado = valor.split('.')
  
            // VERIFICA SE FOI ENCONTRADO UM VALOR
            if (alterado.length >= 2) {
              // VERIFICA SE TEM 4 CASAS DECIMAL E REMOVE AS DUAS ULTIMAS
              if (alterado[1].length === 4) {
                alterado[1] = alterado[1].substring(0, 2)
              }
  
              // ATUALIZA OS VALORES NA TABELA
              valor = alterado.join('')
            }
  
            // SETA O VALOR INICIAL DA PORCENTAGEM
            self.dados._cms_por_ini = self.$store.state.FUN_MASK_VALOR('valorMoeda', valor)
  
            // SETA O STATUS DA TELA
            self.cmsEditarSetaStatusGeral('')
          }, self.cmsEditarSetaStatusGeral)
        } else {
          // SETA O STATUS DA TELA
          self.cmsEditarSetaStatusGeral('')
        }

      },
      cmsEditarAtualizarComissaoVendedor: function () {
        var self = this

        if (self.cms_por.value !== self.cms_por.valueIni) {
          // SETA O STATUS DA TELA
          self.cmsEditarSetaStatusGeral('carregando')

          // CRIA O FORMULARIO QUE SER ENVIADO PARA API
          var formData = { lot: [ { id_con: Number(self.comissionado.value) } ] }

          // PEGA O VALOR PREENCHIDO
          var valor = self.cms_por.value

          // REMOVE OS PONTOS DA STRING
          while (valor.indexOf('.') > -1) {
            valor = valor.replace('.', '')
          }

          // REMOVE OS PONTOS DA STRING
          while (valor.indexOf(',') > -1) {
            valor = valor.replace(',', '.')
          }

          // VERIFICA SE DEVE INFORMAR ZERO EM VEZ DE 000
          if (valor === '000') {
            valor = '0'
          }

          // VERIFICA O TIPO DE INFORMAÇÃO QUE DEVE SER FEITA
          switch (self.cpntTipo) {
            case 'produto':
              formData.lot[0].j_produtos = [ { id_pro: Number(this.dados.id_pro), cms_por: valor } ]
              break
  
            case 'servico':
              formData.lot[0].j_servicos = [ { id_ser: Number(this.dados.id_ser), cms_por: valor } ]
              break
          }
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
  
          // FAZ A COMUNICAÇÃO COM A API
          self.$store.state.comunicaAPI('/comissao/config/comissionado', 'PUT', formData, function (apiSuccess) {
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
              self.cmsEditarAtualizarComissionado()
            })
          }, self.cmsEditarSetaStatusGeral, function (apiValid, apiStatus) {
            self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, {}, true, function () {  
              // SETA O STATUS DA TELA
              self.cmsEditarSetaStatusGeral('')
            })
          })
          }
      },
      cmsEditarAtualizarComissionado: function () {
        var self = this

        // SETA O STATUS DA TELA
        self.cmsEditarSetaStatusGeral('carregando')

        // SETA A ROTA QUE DEVE SER ATUALIZADA
        var router = self.cpntTipo === 'produto' ? '/venda/produto' : '/venda/servico'

        // SETA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = { lot: [ { cod_venda: self.dados.cod_venda, id: self.cpntId, cms_com_id: self.comissionado.value } ] }

        // FAZ A COMUNICAÇÃO COM A API
        self.$store.state.comunicaAPI(router, 'PUT', formData, function (apiSuccess) {
          // APRESENTA A MENSAGEM RETORNADA DA API
          self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
            // SETA QUE DEVE ATUALIZAR A TELA DE TRAS
            self.atualizar = true

            // CHAMA A FUNÇÃO PARA REINICIAR A TELA
            self.cmsEditarIniciar()
          })
        }, self.cmsEditarSetaStatusGeral, function (apiValid, apiStatus) {
          self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, {}, true, function () {
            // CHAMA A FUNÇÃO PARA REINICIAR A TELA
            self.cmsEditarIniciar()
          })
        })
      },

      // FUNÇÕES DE CADASTRO ADICIONAIS DO SISTEMA
      // -=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=
      cmsEditarInformacoesCadastro: function (id) {
        // PEGA OS DADOS RECEBIDOS NO ID
        var index = id.split('--')

        // INICIA OS PARAMETROS
        var params = { acao: 'ABRIR_CADASTRO' }

        // PEGA O TIPO DE REGISTRO QUE ESTA SENDO TRABALHADO
        switch (index[1]) {
          case 'link-contato':
            params.tipo = 'contato'
            break

          case 'link-veiculo':
            params.tipo = 'veiculo'
            break

          case 'link-pet':
            params.tipo = 'pet'
            break

          case 'link-produtos':
            params.tipo = 'produto'
            break

          case 'link-servicos':
            params.tipo = 'servico'
            break

          case 'item':
            params.tipo = this.cpntTipo
            break
        }

        // SETA O ID RECEBIDO
        params.id = index[2]

        switch (index[1]) {
          case 'link_venda':
            this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: 'venda', id: params.id, tipo: 'recibo', formato: 'html' } }).href, '_blank', {}, false)
            break

          case 'link_cms':
            this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'abrir_doc_id', params: { cts: this.$store.state.token.cts, nome: 'comissoes', id: params.id, tipo: 'recibo', formato: 'html' } }).href, '_blank', {}, false)
            break

          case 'link-pco_item':
            switch (index[2]) {
              case 'servicos':
                // SETA O TIPO
                params.tipo = 'servico'

                // SETA O ID ATUALIZADO
                params.id = this.vendas[index[3]].itens[index[4]].id_ven_ser
                break

              case 'produtos':
                // SETA O TIPO
                params.tipo = 'produto'

                // SETA O ID ATUALIZADO
                params.id = this.vendas[index[3]].itens[index[4]].id_ven_pro
                break

              default:
                // SETA O TIPO
                params.tipo = index[2]

                // SETA O ID ATUALIZADO
                params.id = index[3]
                break
            }

            if ([ '', null, undefined ].indexOf(params.tipo) === -1 && [ '', null, undefined ].indexOf(params.id) === -1) {
              this.$router.push({ name: 'pco_painel_form', params: { cts: this.$store.state.token.cts, tipo: params.tipo, id: params.id } })
            }
            break

          default:
            // SETA A FUNÇÃO CALLBACK
            params.callback = this.cmsEditarInformacoesCadastroFechar
    
            // CHAMA A FUNÇÃO PARA ABRIR OS DADOS
            this.$store.commit('SET_ABRIR_CADASTRO', params)
            break
        }
      },
      cmsEditarInformacoesCadastroFechar: function (atualizar) {
        if (atualizar === true) {
          // DESTROY O LOOP DE CARREGAMENTO
          this.cmsEditarDestroyInterval()

          // CHAMA A FUNÇÃO INICIAR TODO O PROCESSO NOVAMENTE
          this.cmsEditarIniciar()
        }
      }
    }
  }
</script>
